import '../sass/citrus-testimonials-carousel.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $citrusTestimonialsCarousels = document.querySelectorAll('.citrus-testimonials-carousel');

    if (!$citrusTestimonialsCarousels) return;

    $citrusTestimonialsCarousels.forEach($citrusTestimonialsCarousels => {
        const $carousel = $citrusTestimonialsCarousels.querySelector('.citrus-testimonials-carousel__carousel');
        const $navPrev = $citrusTestimonialsCarousels.querySelector('.citrus-testimonials-carousel__nav-btn--prev');
        const $navNext = $citrusTestimonialsCarousels.querySelector('.citrus-testimonials-carousel__nav-btn--next');
        const $markerBar = $citrusTestimonialsCarousels.querySelector('.citrus-testimonials-carousel__carousel-marker-bar');

        const initCarousel = () => {
            if (!$carousel) return;
            
            const swiperScript = document.querySelector('#citrus-theme-swiper-js');

            if (!swiperScript) return;

            swiperScript.addEventListener('load', () => {
                const carousel = new Swiper($carousel, {
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true
                    },
                    speed: noMotionPreference.matches ? 500 : 0,
                    loop: true,
                    navigation: {
                        prevEl: $navPrev,
                        nextEl: $navNext,
                    },
                    breakpoints: {
                        768: {
                            allowTouchMove: false,
                        }
                    },
                });

                if ($markerBar) {
                    carousel.on('sliderMove', () => {
                        $markerBar.classList.add('marker__bar--no-animate');

                        $markerBar.style.left = `${carousel?.progressLoop * 100}%`;
                    });

                    carousel.on('touchEnd', () => {
                        $markerBar.classList.remove('marker__bar--no-animate');
                        $markerBar.style.left = `${carousel?.realIndex / (carousel?.slides?.length - 1) * 100}%`;
                    });

                    carousel.on('slideChange', () => {
                        $markerBar.style.left = `${carousel?.realIndex / (carousel?.slides?.length - 1) * 100}%`;
                    });
                }
            });
        };

        initCarousel();
    });
})();
